import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../material.action';
import * as commonActions from '../../../../../../app/common/common.action';
import { httpRequest } from '../../../../../../app/common/util/api-common.util';
import WebapiCommon from '@common/util/webapi.common';
import AnexoPage from './anexo.page';
import { acessoPermitido } from '../../../../../../acessos.seguranca';
import { apiUrl } from '@constants/defaultValues';
import IntlMessage from "../../../../../../helpers/intlMessage";

const languages = [
  {
    name: 'Pedido médico',
  },
  {
    name: 'Doc. Pessoais',
  },
  {
    name: 'Laudo médico',
  },
  {
    name: 'Devolução de Material',
  },
  {
    name: 'Outros',
  },
];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : languages.filter(
      (lang) => lang.name.toLowerCase().slice(0, inputLength) === inputValue
    );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = (suggestion) => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;

class AnexoContainer extends Component {
  constructor() {
    super();
    this.uploadInput = React.createRef();
    this.upload = this.upload.bind(this);
    this.state = {
      novoAnexo: null,
      listagemAnexo: null,
      modal: false,
      descicaoAnexoModal: null,
      modalJustificativa: false,
      justificativa: '',
      arquivo: null,
      value: '',
      suggestions: []
    };
  }

  componentDidMount() {
    this._obterListagemAnexos();
  }

  _obterListagemAnexos() {
    this.props.actions.showFadeCarregando(true);
    WebapiCommon.getListagemAnexo(this.props.detalhes.laudo).then((anexos) => {
      this.props.actions.showFadeCarregando(false);
      /*const novo = this.state.novoAnexo || [] ;
            this.setState({
                novoAnexo: [],
                listagemAnexo: []
            });*/
      this.setState({
        novoAnexo: null,
        anexoBase64 : '',
        listagemAnexo: anexos,
      });
    });
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
      descicaoAnexoModal: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '',
      value,
      onChange: this.onChange,
    };

    return (
      <AnexoPage
        usuario={this.props.usuario}
        uploadInput={this.uploadInput}
        listagemAnexo={this.state.listagemAnexo}
        modal={this.state.modal}
        novoAnexo={this.state.novoAnexo}
        descicaoAnexoModal={this.descicaoAnexoModal}
        onChange2={this.onChange2.bind(this)}
        download={this.download.bind(this)}
        modalOnChangeTexto={this.modalOnChangeTexto.bind(this)}
        existeDescricao={this.existeDescricao.bind(this)}
        cancelarUpload={this.cancelarUpload.bind(this)}
        upload={this.upload}
        excluir={this.excluir.bind(this)}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        exameFinalizado={this.props.exameFinalizado}
        modalJustificativa={this.state.modalJustificativa}
        toggleModalJustificativa={this.toggleModalJustificativa.bind(this)}
        setJustificativa={this.setJustificativa.bind(this)}
        justificativa={this.state.justificativa}
        excluirAnexo={this.excluirAnexo.bind(this)}
        arquivo={this.state.arquivo}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }

  existeDescricao() {
    if (
      this.state.descicaoAnexoModal !== null &&
      this.state.descicaoAnexoModal !== undefined &&
      this.state.descicaoAnexoModal !== ''
    ) {
      return true;
    } else {
      return false;
    }
  }

  modalOnChangeTexto(input) {
    const name = input.currentTarget.value;
    this.setState({
      descicaoAnexoModal: name,
    });
  }
  onChange2(input) {
    const anexo = input.target.files[0];

    let exist = this.state.listagemAnexo.find(function (file) {
      return file.nomeArquivo === anexo.name;
    });

    if (!exist && anexo.name !== '') {
      this.setState({
        modal: true,
        novoAnexo: anexo,
        descicaoAnexoModal: null,
      });
    } else if (anexo.name !== '' || exist) {
      this.props.commonActions.showAlerta(
        'alerta',
        <IntlMessage id = "dashboards.examDetail.attachmentError"/>,
        2000
      );
    }
  }

  cancelarUpload() {
    this.uploadInput.current.value = '';
    this.setState({
      novoAnexo: null,
      modal: false,
    });
  }

  upload() {
    this.setState({ modal: false });

    this.props.actions.showFadeCarregando(true);
    const data = new FormData();
    let file = this.state.novoAnexo;
    this.setState({
      novoAnexo: null
    });
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function() {
      httpRequest(`laudos/${this.props.detalhes.laudo}/anexos`, 'POST', {
        descricao: this.state.descicaoAnexoModal,
        nomeArquivo: file.name,
        base64Anexo :  reader.result.split('base64,')[1]
      }).then(() => {
        this._obterListagemAnexos();
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'sucesso',
          <IntlMessage id = "dashboards.examDetail.successAttached"/>,
          2000
        );
      });

    }.bind(this);
  }

  download(id, nome, contenttype) {
    this.props.actions.showFadeCarregando(true);
    WebapiCommon.downloadAnexo(id)
      .then((response) => response.arrayBuffer())
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res], { type: contenttype })
        );
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = nome;
        document.body.appendChild(link);
        link.click();
        this.props.actions.showFadeCarregando(false);
      });
  }

  setJustificativa(event) {
    this.setState({
      justificativa: event.currentTarget.value,
    });
  }

  toggleModalJustificativa() {
    this.setState({
      arquivo: null,
      modalJustificativa: false,
      justificativa: '',
    });
  }

  excluirAnexo() {
    this.props.actions.showFadeCarregando(true);
    WebapiCommon.excluirAnexo(
      this.state.arquivo.id,
      this.state.justificativa,
      this.state.arquivo.nomeArquivo,
      this.props.detalhes.laudo
    ).then(() => {
      this._obterListagemAnexos();
      this.toggleModalJustificativa();
      this.props.actions.showFadeCarregando(false);
      this.props.commonActions.showAlerta(
        'sucesso',
        <IntlMessage id = "dashboards.examDetail.fileRemoved"/>,
        1500
      );
    });
  }

  excluir(anexo) {
    this.setState({
      arquivo: anexo,
      modalJustificativa: true,
    });
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    exameFinalizado: state.commonReducer.exameFinalizado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnexoContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/anexo/anexo.container.js